import type { FunctionComponent } from 'react';

import { createClassName, createStyleHelper } from '../../../shared/utils/class-names';
// TODO: These should be changed so data would be read from CMS
// Ticket: https://github.com/GiGInnovationLabs/dragon/issues/91
import netellerMockImage from '../payment-methods/mock/neteller.png';
import skrillMockImage from '../payment-methods/mock/skrill.png';
import trustlyMockImage from '../payment-methods/mock/trustly.png';
import visaMockImage from '../payment-methods/mock/visa.png';

import styles from './payment-methods.module.scss';

const style = createStyleHelper(styles, 'payment-methods');

export interface IPaymentMethodsProps {
    className?: string;
}

export const PaymentMethods: FunctionComponent<IPaymentMethodsProps> = ({ className }) => {
    return (
        <div className={createClassName([className, style()])}>
            <div className={style('heading')}>Most popular and safest payment methods</div>
            <div className={style('icons')}>
                <img className={style('payment-icon')} src={visaMockImage} />
                <img className={style('payment-icon')} src={trustlyMockImage} />
                <img className={style('payment-icon')} src={netellerMockImage} />
                <img className={style('payment-icon')} src={skrillMockImage} />
            </div>
        </div>
    );
};
